export default __webpack_public_path__ + "static/testimonials-1-shape-5-42aabfd9fbe1456350c9dd06c982c8c2.png";